// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "label-380IB";
export { _1 as "__esModule", _2 as "label" }
export default { "__esModule": _1, "label": _2 }
